import { convertSimNaoEnumToBoolean } from '@mchat-rf/consulta-seguimento/converter-consultaSeguimento'
import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { ConsultaSeguimentoPergunta03Model } from './model-consultaSeguimentoPergunta03'

export const convertConsultaSeguimentoPergunta03ToInput = (
  value: ConsultaSeguimentoPergunta03Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.BEBIA_XICARA_BRINQUEDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.COMIA_COLHER_BRINQUEDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.FALAVA_TELEFONE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.DAVA_COMIDA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.EMPURRAR_CARRO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.PERSONAGENS_FAVORITOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.PANELA_FOGAO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_09,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.MEXEU_COMIDA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_10,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.MOTORISTA_PASSAGEIRO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_11,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_03_EXEMPLOS?.ASPIRAVA_VARRIA_CORTAVA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_03_12,
      stResposta: convertSimNaoEnumToBoolean(value.OUTRO?.radioValue),
      outros: value.OUTRO?.textValue,
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
